import { Btn } from "@/components/site/Buttons";

export default function NotFound() {
  return (
    <section data-testid="not-found-page" className="flex min-h-[70vh] items-center bg-mist pt-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold-ink">Errore 404</p>
        <h1 className="mt-5 text-4xl font-bold text-navy md:text-6xl">Pagina non trovata.</h1>
        <p className="mt-5 max-w-lg text-base text-slate2">La pagina che cerchi non esiste o è stata spostata.</p>
        <div className="mt-10"><Btn to="/" testId="not-found-home-btn">Torna alla Home</Btn></div>
      </div>
    </section>
  );
}
